import React, { forwardRef } from 'react';
import { Helmet } from 'react-helmet-async';
// material
import { Box, BoxProps, Fade } from '@mui/material';
import { SnackbarProvider } from 'notistack';

import CSnackbar from './custom/snackbar/CSnackbar';

// ----------------------------------------------------------------------

interface PageProps extends BoxProps {
  title?: string;
  needPadding?: boolean;
}

export const Page = forwardRef<HTMLDivElement, PageProps>(
  ({ children, title = '', needPadding = false, sx, ...others }, ref) => (
    <React.Fragment>
      <Helmet>
        <title>{title}</title>
      </Helmet>
      <SnackbarProvider
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        autoHideDuration={3000}
        TransitionComponent={Fade}
      >
        <CSnackbar />
        <Box
          {...others}
          sx={{
            display: 'flex',
            flexDirection: 'column',
            flex: 1,
            height: '100%',
            width: '100%',
            maxWidth: '100%',
            ...(needPadding && { p: '24px' }),
            ...sx,
          }}
        >
          {children}
        </Box>
      </SnackbarProvider>
    </React.Fragment>
  ),
);
